import { useEffect, useState } from "react";
import { http, nf, rp } from "@/lib/api";
import { PageHeader, Stat, KatBadge } from "@/components/Ui";
import AiInsight from "@/components/AiInsight";
import ExportButtons from "@/components/ExportButtons";

export default function ReportProjection() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    http.get("/reports/projection").then((r) => setRows(r.data.rows)).catch(() => setRows([]));
  }, []);

  if (!rows) return <div className="p-8 mono text-sm">Memuat laporan…</div>;
  const totalQty = rows.reduce((a, r) => a + (Number(r.qty_permintaan) || 0), 0);
  const totalNominal = rows.reduce((a, r) => a + (Number(r.total_nominal_proyeksi) || 0), 0);

  return (
    <div data-testid="report-projection-page">
      <PageHeader subtitle="Laporan" title="Laporan Usulan Proyeksi Kebutuhan Material" testId="report-projection-header">
        <ExportButtons kind="projection" testId="export-projection" />
      </PageHeader>
      <div className="p-6 sm:p-8 space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <Stat testId="report-projection-count" label="Jumlah Usulan" value={nf(rows.length)} />
          <Stat testId="report-projection-qty" label="Total Qty Diusulkan" value={nf(totalQty)} accent="#4338CA" />
          <Stat testId="report-projection-nominal" label="Total Nominal Proyeksi" value={rp(totalNominal)} accent="#16A34A" />
          <Stat testId="report-projection-cabang" label="Cabang Pengusul" value={nf(new Set(rows.map((r) => r.nama_cabang)).size)} />
        </div>

        <div className="erp-panel overflow-auto max-h-[70vh]" data-testid="report-projection-table-wrap">
          <table className="erp-table">
            <thead>
              <tr>
                <th>Tanggal Pengajuan</th><th>Cabang</th><th>Kode Stock</th><th>Deskripsi</th>
                <th>Type</th><th>Spesifikasi</th><th className="num">Qty Permintaan</th>
                <th className="num">Harga Jual A</th><th className="num">Total Nominal Proyeksi</th>
                <th>Estimasi Waktu Kebutuhan</th><th>Kategori Pemasaran</th><th>Catatan</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} data-testid={`report-projection-row-${r.kode_stock}`}>
                  <td className="mono">{(r.tanggal_pengajuan || "").slice(0, 10)}</td>
                  <td>{r.nama_cabang}</td>
                  <td className="mono font-medium">{r.kode_stock}</td>
                  <td className="max-w-[200px] truncate">{r.deskripsi_produk}</td>
                  <td>{r.type_produk}</td>
                  <td className="max-w-[220px] truncate">{r.spesifikasi_produk}</td>
                  <td className="num font-semibold">{nf(r.qty_permintaan)}</td>
                  <td className="num">{rp(r.harga_jual_a || 0)}</td>
                  <td className="num font-semibold">{rp(r.total_nominal_proyeksi || 0)}</td>
                  <td>{r.estimasi_waktu_kebutuhan}</td>
                  <td><KatBadge value={r.kategori_pemasaran} /></td>
                  <td className="max-w-[180px] truncate">{r.catatan}</td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td colSpan={12} className="text-center text-neutral-500 py-6">Belum ada usulan proyeksi</td></tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={6}>TOTAL</td>
                <td className="num">{nf(totalQty)}</td>
                <td className="num">—</td>
                <td className="num">{rp(totalNominal)}</td>
                <td colSpan={3}></td>
              </tr>
            </tfoot>
          </table>
        </div>

        <AiInsight scope="proyeksi" />
      </div>
    </div>
  );
}
